(function () {
  var modal = document.getElementById('apply-now-ibe');
  if (!modal) return;

  var formId = modal.getAttribute('data-hs-form-id');
  var formStartSent = false;

  function pushEvent(name) {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      event: name,
      form_id: formId,
      form_name: 'stylist_application',
    });
  }

  function isOpen() {
    return modal.style.display !== 'none' && modal.style.display !== '';
  }

  function syncScrollLock() {
    document.body.classList.toggle('apply-popup-open', isOpen());
  }

  function openPopup() {
    modal.style.display = 'flex';
    modal.style.visibility = 'visible';
    modal.style.opacity = '1';
    syncScrollLock();
  }

  document.addEventListener(
    'click',
    function (event) {
      var anchor = event.target.closest('a[href$="#apply-now-form"], a[href$="#apply-now-ibe"]');
      if (!anchor) return;
      event.preventDefault();
      event.stopPropagation();
      openPopup();
    },
    true
  );

  var openObserver = new MutationObserver(function () {
    syncScrollLock();
    if (!formStartSent && isOpen()) {
      formStartSent = true;
      pushEvent('form_start');
    }
  });
  openObserver.observe(modal, { attributes: true, attributeFilter: ['style'] });

  window.addEventListener('hs-form-event:on-submission:success', function (event) {
    var detail = event && event.detail;
    var submittedId = detail && (detail.formId || detail.form_id);
    if (submittedId && formId && submittedId !== formId) return;
    if (!submittedId && !isOpen()) return;
    pushEvent('form_complete');
  });

  var stepsLabel = modal.querySelector('[data-apply-popup-steps]');
  var currentEl = modal.querySelector('[data-apply-popup-step-current]');
  var totalEl = modal.querySelector('[data-apply-popup-step-total]');
  var progressFill = modal.querySelector('[data-apply-popup-progress]');
  var whatsNext = modal.querySelector('[data-apply-popup-whats-next]');

  function readSteps() {
    var progress = modal.querySelector('.hs-form-html [role="progressbar"]');
    if (progress && progress.hasAttribute('aria-valuenow') && progress.hasAttribute('aria-valuemax')) {
      return {
        current: parseInt(progress.getAttribute('aria-valuenow'), 10),
        total: parseInt(progress.getAttribute('aria-valuemax'), 10),
      };
    }
    var steps = modal.querySelectorAll('.hs-form-html .hsfc-Step');
    if (steps.length > 1) {
      var current = 0;
      steps.forEach(function (step, index) {
        if (step.offsetParent !== null) current = index + 1;
      });
      return { current: current || 1, total: steps.length };
    }
    return null;
  }

  var titleOverrides = {};
  var titlesScript = modal.querySelector('[data-apply-popup-titles]');
  if (titlesScript) {
    try {
      JSON.parse(titlesScript.textContent).split('\n').forEach(function (line) {
        var at = line.indexOf(':');
        if (at === -1) return;
        var key = line.slice(0, at).trim().toLowerCase();
        var title = line.slice(at + 1).trim();
        if (key && title) titleOverrides[key] = title;
      });
    } catch (e) {
    }
  }

  function stepFieldKey(content) {
    var fields = content.querySelectorAll('input, select, textarea');
    for (var i = 0; i < fields.length; i++) {
      if (fields[i].name && fields[i].name.indexOf('/') !== -1) {
        return fields[i].name.split('/').pop().toLowerCase();
      }
    }
    return null;
  }

  function stepLabelText(content) {
    var labels = content.querySelectorAll('label');
    for (var i = 0; i < labels.length; i++) {
      if (!labels[i].querySelector('input')) {
        return labels[i].textContent.replace(/\*\s*$/, '').trim();
      }
    }
    return null;
  }

  function ensureStepHeading() {
    var steps = modal.querySelectorAll('.hs-form-html .hsfc-Step');
    steps.forEach(function (step, index) {
      var content = step.querySelector('.hsfc-Step__Content') || step;
      if (content.querySelector('.apply-popup__question')) return;
      var key = stepFieldKey(content);
      var existing = content.querySelector('.hsfc-Heading, h1, h2, h3');
      var title = titleOverrides[String(index + 1)] || (key && titleOverrides[key]);
      if (title) {
        if (existing) existing.classList.add('apply-popup__hs-heading--replaced');
      } else if (existing) {
        return;
      } else {
        title = stepLabelText(content);
        if (!title) return;
      }
      var heading = document.createElement('h2');
      heading.className = 'apply-popup__question';
      heading.textContent = title;
      content.insertBefore(heading, content.firstChild);
    });
  }

  function updateSteps() {
    if (!stepsLabel) return;
    ensureStepHeading();
    var state = readSteps();
    if (state && state.total > 1 && state.current >= 1) {
      currentEl.textContent = state.current;
      totalEl.textContent = state.total;
      if (progressFill) {
        progressFill.style.width = Math.round((state.current / state.total) * 100) + '%';
      }
      stepsLabel.hidden = false;
      if (whatsNext) whatsNext.hidden = state.current > 1;
    } else {
      stepsLabel.hidden = true;
    }
  }

  // HubSpot picks the phone country from the visitor's IP, so a US number entered
  // on a non-US connection is filed under the wrong dial code. setFieldValue sets a
  // value rather than a default region — emptying the field reverts it to the IP
  // country — so re-assert while the field holds no digits, and stop once the
  // visitor picks a country themselves.
  var BARE_DIAL_CODE = /^\s*(\+\d{1,3})?\s*$/;

  function defaultPhoneToUs(form) {
    var field = modal.querySelector('.hsfc-PhoneField');
    var input = field && field.querySelector('input[type="tel"]');
    if (!form || !input) return;

    var countryPicked = false;
    field.addEventListener('click', function (event) {
      if (event.target.closest('.hsfc-DropdownOptions__List__ListItem')) countryPicked = true;
    });

    function assertUs() {
      if (countryPicked || input.value.trim() === '+1') return;
      if (!BARE_DIAL_CODE.test(input.value)) return;
      form.setFieldValue('0-1/phone', '+1');
    }

    assertUs();
    // Deferred: calling setFieldValue synchronously here is clobbered by the
    // render HubSpot is already running for this same input event.
    input.addEventListener('input', function () {
      setTimeout(assertUs, 0);
    });
  }

  modal.classList.add('apply-popup--loading');
  function reveal() {
    modal.classList.remove('apply-popup--loading');
  }
  var revealFallback = setTimeout(reveal, 4000);

  window.addEventListener('hs-form-event:on-ready', function (event) {
    updateSteps();
    if (window.HubSpotFormsV4) {
      defaultPhoneToUs(window.HubSpotFormsV4.getFormFromEvent(event));
    }
    clearTimeout(revealFallback);
    reveal();
    var formRoot = modal.querySelector('.hs-form-html');
    if (formRoot) {
      new MutationObserver(updateSteps).observe(formRoot, { childList: true, subtree: true, attributes: true });
    }
  });
})();
